<script>
    export let url = null;
    export let actual = false;
</script>

<style>
    .miga:not(:last-child):after {
        content: '/';
        display: inline-block;
        margin: 0 .5em;
        font-size: .9em;
    }

    a, button {
        color: #757575;
    }

    a:not(:hover) {
        text-decoration: none;
    }

    button {
        font-family: inherit;
        font-size: inherit;
    }
</style>

<div class="miga">
    {#if actual}
        <slot/>
    {:else if url}
        <a href={url}>
            <slot/>
        </a>
    {:else}
        <button on:click>
            <slot/>
        </button>
    {/if}
</div>